module.exports = __webpack_public_path__ + "static/media/tableedit.b6b7a49d.svg";